export default "__VITE_ASSET__62907386__"